module.exports = __webpack_public_path__ + "static/Helle_H_43-67d2b0bbdc20165a4ef7c9cc945ae87c.jpg";